import {twMerge} from "tailwind-merge";

export function VerticalSpacer({className}: {className?: string}) {
    if (className == null) {
        className = "h-8";
    }

    return <div className={twMerge("flex-none self-stretch", className)}></div>;
}
